<div class="row mt-2 no-gutters">
  <div class="col">
    <small *ngIf="accountCategory== 'RENTAL_FLEET'"><a [routerLink]="['/rental-fleet']" class="text-secondary">Developer Portal</a>
      /<a [routerLink]="['/swagger-ui']"  class="text-secondary" (click)="onCloseSwagger()"> Developer APIs</a></small>
    <small *ngIf="accountCategory== 'FLEET_MANAGEMENT_COMPANY' || accountCategory == 'MOBILITY_COMPANY' || accountCategory == 'FIELD_SERVICE_COMPANY'"><a [routerLink]="['/commercial-fleet']"
        class="text-secondary" (click)="onCloseSwagger()">Developer Portal</a>
      /<a [routerLink]="['/swagger-ui']" class="text-secondary" (click)="onCloseSwagger()"> Developer APIs</a></small>
    <small *ngIf="accountType== 'VEHICLE_SERVICE_PROVIDER'"><a [routerLink]="['/service-provider/dashboard']"
        class="text-secondary" (click)="onCloseSwagger()">Developer Portal</a>
      /<a [routerLink]="['/swagger-ui']" class="text-secondary" (click)="onCloseSwagger()"> Developer APIs</a></small>
    <!-- <small class="text-secondary" *ngIf="showSwagger"> / {{selectedSwaggerResource.name}}</small> -->
  </div>
</div>

<div class="row mt-3 mb-2 no-gutters">
  <div class="col-3">
    <div class="header-medium">Service Module</div>
    <div class="font13-400 py-3 pointer" *ngFor="let resource of swaggerResources; let i = index" (click)="openSwagger(resource)">
      <span [ngClass]="selectedSwaggerResource && selectedSwaggerResource.name == resource.name ? 'selected-nav font13-600' : ''">{{resource.name}}</span>
    </div>
  </div>
  <div class="col-9">
    <div class="float-right mb-2">
      <button type="button" class="btn btn-primary" (click)="downloadPdf()">Download As PDF</button>
    </div>
    <div id="swagger-ui"></div>
  </div>
</div>